import 'ui-core/plugins/slide/js/slide';
import Tooltip from '../../../components/tooltip/js/tooltip';

UX.slide.vPort = 'screen-md';

UX.slide.on.destroyJcf = function ($el) {};
UX.slide.on.rebuildJcf = function ($el) {};

// @todo: should do cleanup after finish UX3 process by remove focus from UX.slide.on.hide() (when close mobile navigation menu) - according to LIT-287810.

UX.slide.on.hide = function (e) {
    const $body = $('body'),
        isInsideSlide = $(e.target).closest('.w-slide').length;

    /**
     * Fire "close" event
     * this event is Cancelable: which means if e.preventDefault() is called then the slide will not close.
     */
    const closingEvent = $.Event('slide:close');
    $(document).trigger(closingEvent, [UX.slide]);
    if (closingEvent.isDefaultPrevented()) {
        return;
    }

    if (typeof e !== 'undefined' && $('.w-slide').hasClass('js--open')) {
        if (!isInsideSlide) {
            UX.slide.back = true;
        }
    }

    if (UX.slide.back) {
        UX.slide.addTransition();
        UX.slide.$slideinfo.hide().removeClass('js--open');

        UX.slide.nested = true;

        if (UX.slide.activeSlide === 0) {
            UX.slide.nested = false;
            UX.slide.$contents = UX.slide.$elements.children('.w-slide__content');
        } else {
            UX.slide.$contents = $('.nested--' + UX.slide.activeSlide);
        }
        UX.slide.on.destroyJcf(UX.slide.$contents);

        let originalTarget = $(UX.slide.$contents.attr('original-target'));
        if (!originalTarget) {
            originalTarget = $body;
        }

        const isLoi = UX.slide.$elements.find('.loi').length > 0;

        UX.slide.on.beforeReturnSlideContent();

        if (isLoi) {
            const $dropBlockHolder = $('.dropBlock-loi__holder');
            $dropBlockHolder.append(UX.slide.$contents.html());
            $dropBlockHolder.find('.loi__list').each(function () {
                UX.loi.on.recalculate($(this));
            });
        } else {
            if (UX.slide.$contents.find('[class*=nested--]').length) {
                UX.slide.$contents.find('[class*=nested--]').remove();
            }

            if (UX.slide.clone === 'self') {
                if (UX.slide.nested || UX.slide.multi) {
                    const $returnNestedDataSlideHere = $('.returnNestedDataSlideHere');
                    $returnNestedDataSlideHere.after(UX.slide.$contents.html());
                    $returnNestedDataSlideHere.remove();
                } else {
                    const $returnDataSlideHere = $('.returnDataSlideHere');
                    $returnDataSlideHere.after(UX.slide.$contents.html());
                    $returnDataSlideHere.remove();
                }
            } else {
                if (UX.slide.nested || UX.slide.multi) {
                    $('.returnNestedDataSlideHere', originalTarget).after(UX.slide.$contents.html());
                    $('.returnNestedDataSlideHere', originalTarget).remove();
                } else {
                    $('.returnDataSlideHere', originalTarget).after(UX.slide.$contents.html());
                    $('.returnDataSlideHere', originalTarget).remove();
                }
            }
            UX.slide.on.rebuildJcf(originalTarget);
        }

        UX.slide.oldInfo.splice(UX.slide.activeSlide, 1);
        UX.slide.$slideinfo.html(UX.slide.oldInfo[UX.slide.activeSlide - 1]);

        if (UX.slide.nested) {
            UX.slide.activeSlide--;
            UX.slide.on._hideSlide();
            if (UX.slide.multi) {
                UX.slide.$contents.remove();
            }
            UX.slide.$contents = $('.nested--' + UX.slide.activeSlide);
            if (UX.slide.activeSlide === 0) {
                UX.slide.$contents = UX.slide.$elements.children('.w-slide__content');
            }
        } else {
            UX.slide.activeSlide = 0;
            $('body, html').removeClass('lock-screen');
            $body.removeClass('lock-screen slide-is-active').removeAttr('data-active');
            const $coolBar = $('.coolBar');
            if ($coolBar.length) {
                $coolBar.removeClass('slide');
            }

            UX.slide.on._hideSlide();
            UX.slide.$elements.removeClass('js--open');
        }
        UX.slide.$slideinfo.show().addClass('js--open');

        UX.slide.backLabel = 'back';
        UX.slide.setBackLabel();
        UX.slide.on.additionalHide(e);

        if (UX.slide.$elements.hasClass('w-slide__pill')) {
            while (UX.slide.activeSlide > 0) {
                UX.slide.activeSlide--;
                UX.slide.on.hide(e);
            }

            if (
                typeof e !== 'undefined' &&
                ($(e.target).hasClass('w-slide__back') || $(e.currentTarget).hasClass('w-slide__back')) &&
                UX.slide.activeSlide === 0
            ) {
                UX.slide.on.off(e);
            }
        }

        if (!isInsideSlide && !(typeof e !== 'undefined' && $(e.target).closest('.pill-list').length)) {
            UX.slide.on.off(e);
        }

        UX.slide.removeTransition();
    }

    // This is needed for refreshing the google ads iframe
    // because we are cloning it into element
    // for more info:  https://stackoverflow.com/questions/435391/refresh-a-div-that-has-a-google-ad-inside-it/12083756#12083756
    if (typeof googletag !== 'undefined' && typeof googletag.pubads !== 'undefined') {
        googletag.pubads().refresh();
    }

    // "closed" event
    const closeEvent = $.Event('slide:closed');
    $(document).trigger(closeEvent, [UX.slide]);
};

UX.slide.displaySlideHtmlToPage = () => {
    UX.slide.$slide = `
        <div class="w-slide">
            <div class="w-slide_head">
                <a href="javascript:void(0)" class="w-slide__back">
                    <i class=" icon-arrow_l" aria-hidden="true"></i>
                    <span>${UX.slide.backLabel}</span>
                </a>
                <span class="w-slide__title"></span>
            </div>
            <div class="w-slide__content"></div>
        </div>
    `;

    UX.slide.$elements = $(UX.slide.$slide);

    const $body = $('body'),
        $main = $('main');

    if ($main.length > 0) $main.append(UX.slide.$elements);
    else $body.append(UX.slide.$elements);
};

UX.slide.control = function () {
    const $body = $('body');

    $body.on('click', '.w-slide__btn', function (e) {
        if (e.currentTarget.getAttribute('href').includes('/')) {
            return;
        }
        if (UX.slide.isMobile) {
            $(this).addClass('slide-active');
        }
        const $this = $(this);

        if (UX.slide.isQueue && UX.slide.isMobile) {
            e.stopImmediatePropagation();
            $(this).off('click');
            return false;
        }
        UX.slide.isQueue = true;

        if ($(this).hasClass('disable')) {
            e.stopPropagation();
            e.preventDefault();
            return;
        }

        if ($(this).hasClass('slide-active')) {
            e.stopPropagation();
            e.preventDefault();
            UX.slide.addTransition();
            UX.slide.$toggle = $(this);
            UX.slide.$target = $(UX.slide.$toggle.data('slide-target'));
            UX.slide.back = false;
            // @todo: should do cleanup after finish UX3 process (add these changes to slide.control()) - according to LIT-278268.
            $this.closest('li').addClass('js--slide').siblings().removeClass('js--slide');
            if ($this.is('[id*=pane-pcw]') && UX.loader.isArticleTabEmpty($(this))) {
                $this.closest('[data-db-target-of]').addClass('js--loading').focus();
                setTimeout(function () {
                    $this.closest('[data-db-target-of="article"]').removeClass('js--loading');
                    $(UX.loader.target).removeClass('empty');
                    UX.slide.on.show(e);
                }, 3000);
            } else {
                UX.slide.on.show(e);
                if (document.querySelector('.tooltip')) {
                    if (!UX.tooltip) {
                        UX.tooltip = new Tooltip().initialize();
                    } else {
                        UX.tooltip.reinitialize();
                    }
                }
            }
        }
    });
    $body.on('click', '.w-slide__back, .w-slide__hide', function (e) {
        if (!e.target.closest('.sections__drop.rlist.separator')) {
            const $this = $(this);

            if ($('.js--slide').length && !$this.hasClass('js--bib')) {
                !$('[data-db-target-for="article"]').hasClass('js--open') &&
                    $('[data-db-target-for="article"]').trigger('click');
                setTimeout(() => {
                    $('.js--slide').find('a').eq(0).focus();
                }, 250);
            } else if ($('.js--scrollTab').length) {
                setTimeout(() => {
                    $('.js--scrollTab').focus();
                }, 230);
            }
            $this.removeClass('js--bib');

            UX.slide.back = true;
            UX.slide.on.hide(e);
        }
    });
};

UX.slide.on.additionalShowSlide = function () {
    const scrollTabEl = $('.js--scrollTab'),
        scrollTabAttr = scrollTabEl.attr('href'),
        tapTargetEl = $(`${scrollTabAttr}`);

    if (UX.tab.isMobile && UX.tab.isMobile[0]) {
        const slideContent = $('.w-slide__content');
        UX.tab.animate.scroll(slideContent, tapTargetEl);
    }
};
